<template>
  <div class="iron-test-modal">
    <div class="iron-test-modal__content">
      <template v-if="result">
        <section class="iron-test-modal__result result-card">
          <div class="result-card__icon">
            <img src="/dist/img/test/Succes.png" alt="success" />
          </div>

          <p class="result-card__title">{{ result.title }}</p>
          <p class="result-card__description">{{ result.description }}</p>
          <p class="result-card__gift-text">{{ result.giftText }}</p>

          <a class="iron-test-modal__button t-btn _green" :href="result.giftLink" target="_blank" rel="noopener noreferrer">
            {{ result.giftBtnText }}
          </a>
        </section>
      </template>

      <template v-else>
        <section class="iron-test-modal__quiz">
          <div class="iron-test-modal__header">
            <h2 class="iron-test-modal__title">Тест: «Какой ты железный партнёр?»</h2>
            <p class="iron-test-modal__subtitle">
              Ответьте на 8 вопросов и найдите свой тип в результатах!
            </p>
          </div>

          <div class="iron-test-modal__body">
            <p class="iron-test-modal__question">
              {{ currentQuestion.question }}
            </p>

            <ul class="iron-test-modal__options">
              <li
                v-for="(option, optionIndex) in currentQuestion.options"
                :key="`${currentStep}_${optionIndex}`"
                class="iron-test-modal__option"
              >
                <label class="radio-option">
                  <input
                    v-model="selectedOptionIndex"
                    class="radio-option__input"
                    type="radio"
                    :name="`question-${currentStep}`"
                    :value="optionIndex"
                  />
                  <span class="radio-option__control"></span>
                  <span class="radio-option__text">{{ option }}</span>
                </label>
              </li>
            </ul>

            <img v-if="currentQuestion.icon" :src="currentQuestion.icon" class="iron-test-modal__illustration" alt="Иконка шага" />
          </div>

          <footer class="iron-test-modal__footer">
            <div class="iron-test-modal__progress progress">
              <ul class="progress__list">
                <li v-for="(_, index) in questions" :key="index" class="progress__item">
                  <img
                    class="progress__coin"
                    src="/dist/img/test/ironPartner/step-coin.png"
                    :alt="`Монета за вопрос ${index + 1}`"
                    :data-completed="answers[index] !== null"
                  />
                </li>
              </ul>
            </div>

            <div class="iron-test-modal__actions">
              <img
                v-if="currentQuestion.icon"
                :src="currentQuestion.icon"
                class="iron-test-modal__illustration iron-test-modal__illustration--mobile"
                alt="Иконка шага"
              />

              <button
                class="iron-test-modal__button iron-test-modal__button--next t-btn _green"
                type="button"
                :disabled="selectedOptionIndex === null"
                @click="goToNextStep"
              >
                Далее
              </button>
            </div>
          </footer>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IronPartnerModal',
  data() {
    return {
      currentStep: 0,
      selectedOptionIndex: null,
      resultIndex: null,
      answers: [],
      questions: [
        {
          question: 'Заказчик просит срочно поставить ему сервер, но нужной конфигурации нет на складе. Ваши действия?',
          icon: '/dist/img/test/ironPartner/axpaka-fly.png',
          options: [
            'Предложу аналог с улучшенными характеристиками и скидкой — пусть радуется!',
            'Скажу правду: «Ждать 3 месяца, брат», — и предложу чай',
            'Обращусь за помощью в Axoft, договорюсь о срочной доставке, возьму небольшой бонус за оперативность',
            'Пообещаю завтра, а ночью сам поеду на склад и всё организую',
            '«У нас есть прототип — экспериментальная модель. Хотите протестировать?»',
            '«Давайте подпишем договор сейчас, а модель уточним позже — так даже гибче!»',
          ],
        },
        {
          question: 'Заказчик хочет «самый надёжный сервер, чтобы работал 10 лет без сбоев». Что отвечаете?',
          options: [
            '«Конечно! Вот модель с гарантией 7 лет и пожизненной техподдержкой (шучу, 5 лет)»',
            '«Всё сломается. Но мы будем рядом с запчастями — как верные друзья»',
            'Вместе с инженерами Axoft сервер с ECC‑памятью, RAID 10 и резервным БП, объясню про регулярное ТО',
            '«Будет работать 11 лет — я лично его благословлю!»',
            '«Возьмём два: один работает, второй — горячий резерв. Надёжность — 200%!»',
            '«А давайте сначала определим, какие 10% времени он может не работать — так дешевле выйдет!»',
          ],
        },
        {
          question: 'Привезли оборудование, а в документации ошибка в серийных номерах. Ваша реакция?',
          options: [
            'Исправлю в Excel и отправлю клиенту: «Так и было задумано»',
            'Позову коллегу: «Смотри, какой прикол! Давай сфоткаем и в чат»',
            'Так не бывает, я же размещал заказ через Axoft Online!',
            'Перепишу от руки, поставлю красивую печать — главное, чтобы работало',
            'Напишу клиенту: «Это специальная ограниченная серия с уникальными номерами»',
            'Запущу процесс замены всей партии — репутация важнее мелочей',
          ],
        },
        {
          question: 'Клиент звонит в 23:00: «Сервер горит красным, что делать?!» Ваши действия?',
          options: [
            'Отвечу: «Это индикатор красоты. Всё в порядке, спите спокойно»',
            'Включу режим «мудрого наставника»: «Дышите глубже. Сначала проверьте питание…»',
            'Зайду удалённо, проверю логи, дам чёткие инструкции, отправлю инструкцию по профилактике',
            'Брошу все дела, поеду на объект — вдруг там действительно пожар?',
            'Предложу VIP‑поддержку за двойную оплату — но только сегодня',
            '«Сейчас подключу дежурного инженера Axoft, он вас проведёт по чек‑листу»',
          ],
        },
        {
          question: 'На выставке вам предлагают «супервыгодную» партию железа без документов. Ваше решение?',
          options: [
            'Куплю две партии — одну продам, вторую спрячу «на чёрный день»',
            'Откажусь: «Спасибо, но я предпочитаю спать спокойно»',
            'У меня и так супервыгодные условия на поставку железа у одного дистриьбьютора. На “A” начинается, на “xoft” заканчивается.',
            'Соглашусь, но попрошу скидку за риск — и сразу начну искать покупателя',
            '«А можно половину сейчас, половину — когда появятся документы?»',
            '«Сначала — аудит производства. Потом — переговоры»',
          ],
        },
        {
          question: 'Клиент просит смету «ещё вчера», а спецификации ещё нет. Ваши действия?',
          options: [
            'Составлю смету из головы, потом подгоню под реальность',
            'Отвечу: «Без спецификаций — только в долларах и с коэффициентом 1,5»',
            'Всё предоставлю, ведь Axoft предоставил все данные ещё «позавчера»',
            'Напишу: «Смета готова! (Приложение: пустой файл. Жду спецификаций)»',
            'Предложу пакетное решение «всё включено» — так проще',
            'Разделю проект на этапы и дам смету по первому этапу',
          ],
        },
        {
          question: 'Заказчик хочет сэкономить и просит «такой же сервер, но в два раза дешевле». Ваш ответ?',
          options: [
            '«Есть вариант с особыми комплектующими — работает на удачу!»',
            '«Давайте уберём половину функций — сэкономим 40%, а не 50%»',
            'Посоветуюсь со своим дистрибьютором и вместе подберём аналоги со схожими характеристиками',
            'Сделаю сборку из проверенных компонентов — снижу цену без потери надёжности',
            '«Окей, но тогда и поддержка — раз в месяц по вторникам»',
            'Проанализирую ТЗ и предложу оптимизацию  — возможно, мощный сервер не нужен',
          ],
        },
        {
          question: 'Клиент недоволен: «Вы обещали поставить за неделю, а прошло две!» Ваши действия?',
          options: [
            '«Зато теперь у вас сервер с апгрейдом — мы добавили SSD бесплатно!»',
            '«Неделя — семь рабочих дней, а мы считали календарные. Но я понимаю вашу грусть»',
            'Привезу оборудование лично, извинюсь, предложу скидку на следующий заказ, который лучше было заказывать в Axoft',
            'Объясню причины задержки, пришлю фото грузовика с грузом — он уже в пути!',
            '«Давайте перепишем договор задним числом — так будет проще для всех»',
            'Проведу разбор полётов внутри команды, внедрю новый график поставок, чтобы такого не повторилось',
          ],
        },
      ],
      results: [
        {
          title: 'Креативный оптимизатор',
          description:
            'Вы мастер обходить острые углы и находить нестандартные решения. Клиенты вас любят за лёгкость, но иногда беспокоятся: «А точно всё будет работать?». Ваш девиз: «Главное — не париться, а железо само как‑нибудь».',
          giftText: 'И чтобы не париться дальше, вот вам наша шпаргалка с портфелем HW-вендоров Axoft. Пользуйтесь!',
          giftBtnText: 'Шпаргалка',
          giftLink: 'https://form.axoft.ru/iron-cheat-sheets',
        },
        {
          title: 'Философ-реалист',
          description:
            'Вы знаете, что всё когда‑нибудьсломается, и относитесь к этому с юмором. Вы не обещаете чудес, зато честно предупреждаете о подводных камнях. Клиенты ценят вашу прямоту, хотя иногда мечтают о чуть большей уверенности в голосе.',
          giftText: 'И с этим мы всегда готовы помочь! Держите шпаргалки по нашим HW-вендорам для ещё большей уверенности!',
          giftBtnText: 'Шпаргалка',
          giftLink: 'https://form.axoft.ru/iron-cheat-sheets',
        },
        {
          title: 'Профессиональный инженер',
          description:
            'Вы — эталон надёжности. Документы в порядке, оборудование протестировано, план Б всегда под рукой. Клиенты спят спокойно, зная, что их серверы в надёжных руках. Вы верите в стандарты, регламенты и здравый смысл. В общем, вы надёжный партнёр Axoft и всегда уверены в поставляемом оборудовании.',
          giftText: 'Обязательно берите на вооружение наш чек-лист "Как выбрать сервер под бюджет и регуляторные требования"',
          giftBtnText: 'Чек-лист',
          giftLink: 'https://hw.axoftglobal.ru/hardware-server-check-list',
        },
        {
          title: 'Герой-спасатель',
          description:
            'Вы готовы бросить всё и мчаться на помощь в любое время суток. Для вас нет слова «невозможно», есть только «сейчас решим». Клиенты обожают вас, но коллеги иногда вздыхают: «Опять он всё на себе тащит…».',
          giftText: 'Мы решили облегчить немного ваши заботы и дарим чек-лист по импортозамещению рабочего места',
          giftBtnText: 'Чек-лист',
          giftLink: 'https://hw.axoftglobal.ru/hardware-check-list',
        },
        {
          title: 'Цифровой минималист',
          description:
            'Вы ненавидите бюрократию и ищете простые решения. Зачем сложный договор, если можно устно договориться? Зачем дорогой сервер, если хватит старого с апгрейдом? Ваша суперсила — упрощать, но иногда клиенты хотят чуть больше формальности.',
          giftText: 'И вот вам совершенно бесплатно простой чек-лист по импортозамещению рабочего места.',
          giftBtnText: 'Чек-лист',
          giftLink: 'https://hw.axoftglobal.ru/hardware-check-list',
        },
        {
          title: 'Легендарный переговорщик',
          description:
            'Вы видите возможности там, где другие видят проблемы. Любой запрос клиента — повод предложить новое решение. Вы мастер компромиссов, умеете считать риски и строить долгосрочные отношения. Клиенты доверяют вам, потому что вы всегда находите выход.',
          giftText: 'А с Axoft его будет найти проще простого, используя наши "железные" шпаргалки!',
          giftBtnText: 'Шпаргалка',
          giftLink: 'https://form.axoft.ru/iron-cheat-sheets',
        },
      ],
    }
  },

  computed: {
    currentQuestion() {
      return this.questions[this.currentStep]
    },

    isLastStep() {
      return this.currentStep === this.questions.length - 1
    },

    result() {
      if (this.resultIndex === null) return null
      return this.results[this.resultIndex] || null
    },
  },

  created() {
    this.answers = new Array(this.questions.length).fill(null)
  },

  methods: {
    goToNextStep() {
      if (this.selectedOptionIndex === null) return

      this.$set(this.answers, this.currentStep, this.selectedOptionIndex)

      if (this.isLastStep) {
        this.calculateResult()
        return
      }

      this.currentStep += 1
      this.selectedOptionIndex = this.answers[this.currentStep]
    },

    calculateResult() {
      const frequencyMap = this.answers.reduce((acc, answerIndex) => {
        if (answerIndex === null) return acc

        acc[answerIndex] = (acc[answerIndex] || 0) + 1
        return acc
      }, {})

      let mostFrequentIndex = Object.keys(frequencyMap)[0]

      Object.keys(frequencyMap).forEach(key => {
        if (frequencyMap[key] > frequencyMap[mostFrequentIndex]) {
          mostFrequentIndex = Number(key)
        }
      })

      this.resultIndex = mostFrequentIndex
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.t-modal__container
  @media (max-width: $tablet-size)
    overflow: auto !important

.iron-test-modal
  --brand: #00B0BD

  width: 90vw
  max-width: 860px

  @media (max-width: $mobile-size)
    width: auto

  &__content
    position: relative
    line-height: 1

  &__title
    color: $base-text
    font-size: 40px
    font-weight: 600
    line-height: 1.1

    @media (max-width: $mobile-size)
      font-size: 28px
      padding-right: 37px

  &__subtitle
    font-size: 18px
    padding-block: 9px 20px

  &__question
    font-size: 18px
    font-weight: 700

  &__options
    margin: 0
    padding: 0
    list-style: none

  &__option
    margin-top: 20px

  &__illustration
    width: 307px
    position: absolute
    right: -214px
    top: 15%

    &--mobile
      display: none

    @media (max-width: $tablet-size)
      &:not(.iron-test-modal__illustration--mobile)
        display: none

      &.iron-test-modal__illustration--mobile
        width: 190px
        display: block
        position: static

  &__footer
    display: flex
    justify-content: space-between
    gap: 20px
    margin-top: 30px

    @media (max-width: $tablet-size)
      flex-direction: column
      align-items: center
      gap: 20px

  &__actions
    @media (max-width: $tablet-size)
      width: 100%
      display: flex
      justify-content: space-between
      gap: 10px

  &__button
    align-content: center
    width: 220px
    height: auto
    font-size: 16px !important
    line-height: 1.4 !important
    font-weight: 600 !important

    &:disabled
      opacity: .6
      cursor: not-allowed

  &__button--next
    @media (max-width: $tablet-size)
      align-self: flex-end
      margin-left: auto

.result-card
  max-width: 715px

  &__icon
    margin-top: 46px

  &__title
    font-size: 28px
    font-weight: 600
    margin-block: 32px 17px

  &__description,
  &__gift-text
    font-size: 18px

  &__gift-text
    margin-block: 32px

.radio-option
  display: flex
  gap: 31px
  align-items: center
  cursor: pointer
  user-select: none

  @media (max-width: $mobile-size)
    gap: 15px

  &__input
    position: absolute
    opacity: 0
    pointer-events: none

  &__control
    display: inline-block
    width: 24px
    height: 24px
    border: 1px solid #C8C8C8
    border-radius: 4px
    transition: all .2s
    background: #FFFFFF
    position: relative
    flex: 0 0 24px

  &__input:focus-visible + .radio-option__control
    outline: 2px solid #94A3B8
    outline-offset: 2px

  &__input:checked + .radio-option__control
    border-color: var(--brand)

  &__input:checked + .radio-option__control::after
    content: ""
    position: absolute
    inset: 5px
    border-radius: 4px
    background: var(--brand)

  &__text
    flex: 1
    font-size: 18px

    @media (max-width: $mobile-size)
      font-size: 16px

.progress
  &__list
    display: flex
    align-items: center
    flex-wrap: nowrap
    gap: 25px
    list-style: none
    width: fit-content
    background: #fff
    margin: 0
    padding: 0

    @media (max-width: $mobile-size)
      margin: 0 auto
      gap: 10px

  &__item
    max-height: 48px
    aspect-ratio: 1 / 1
    border-radius: 50%
    background: #D9D9D9
    display: grid
    place-items: center
    overflow: hidden

  &__coin
    opacity: 0
    transform: rotate(0deg)
    transition: opacity 0.6s ease, transform 0.6s ease, scale 0.3s
    display: block
    object-fit: cover

    &[data-completed="true"]
      opacity: 1
      transform: rotate(360deg)
      cursor: pointer

      &:hover
        scale: 1.2
</style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/iron-partner-modal.vue